/**
 * Fixture for the swarm-status widget — shape of swarm_status's
 * structured output (mcp/server.ts swarmStatusTool): machine views with
 * phase-9 seat labels, active/needs-human sessions, job counts, schedule
 * count, and the §B2 budget block with a seat-limited chip example.
 */
import { LIVE_SESSION_ID, MACHINES, minAgo } from "./seed";

export function swarmStatusFixture(): Record<string, unknown> {
  const liveSession = {
    sessionId: LIVE_SESSION_ID,
    agent: "email-triage",
    machineId: MACHINES.mini.machineId,
    machineName: MACHINES.mini.name,
    status: "running",
    startedAt: minAgo(14),
  };
  return {
    machines: [
      {
        machineId: MACHINES.mini.machineId,
        name: MACHINES.mini.name,
        status: "online",
        lastSeenAt: minAgo(1),
        activeSessionCount: 1,
        tonightTokens: {
          inputTokens: 612_000,
          outputTokens: 118_000,
          cacheReadTokens: 2_400_000,
          cacheWriteTokens: 96_000,
        },
        seatId: MACHINES.mini.seatId,
        seatLabel: MACHINES.mini.seatLabel,
      },
      {
        machineId: MACHINES.air.machineId,
        name: MACHINES.air.name,
        status: "offline",
        lastSeenAt: minAgo(190),
        activeSessionCount: 0,
        tonightTokens: {
          inputTokens: 88_000,
          outputTokens: 21_000,
          cacheReadTokens: 310_000,
          cacheWriteTokens: 12_000,
        },
        seatId: MACHINES.air.seatId,
        seatLabel: MACHINES.air.seatLabel,
      },
    ],
    activeSessions: [{ ...liveSession, needsHuman: true }],
    needsHumanSessions: [liveSession],
    jobs: { queued: 2, failed: 1 },
    scheduleCount: 3,
    // Phase-9 §B2: cap + current-night usage + the seat-limited chips.
    budget: {
      tokensPerNight: 2_000_000,
      windowUsed: 1_460_000,
      insideWindow: true,
      seatLimitedSeats: [
        { label: MACHINES.air.seatLabel, since: minAgo(95) },
      ],
    },
    teamRef: null,
    teamName: null,
  };
}
